"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var transform = function (converters) { return function (params, locale) { return (Object.keys(params).map(function (i) {
    var key = i;
    // Encode all the params, so UTF-8 etc. are handled correctly
    // Note! Browsers pretty much do this, but on Node.js does not
    var value = encodeURIComponent(params[key]);
    var conversion = converters[key];
    // Conversion rule can be a function. If so, execute and return
    if (typeof conversion === 'function') {
        return conversion(key, value, locale, params);
    }
    // Otherwise we expect rule to be regexp
    // Convert the query key to the API format
    if (conversion && conversion.key) {
        key = key.replace(conversion.key[0], conversion.key[1]);
    }
    // Convert the query value to the API format
    if (conversion && conversion.value) {
        value = value.replace(conversion.value[0], conversion.value[1]);
    }
    // Then join the values by '=' and return
    return "".concat(key, "=").concat(value);
})); }; };
exports.default = transform;
